<template>
	<nk-wrapper v-if="context" spacing="lg">
		<div
			v-if="context.einleitung"
			class="mb-3 einleitung"
			v-html="context.einleitung"
		/>
		<nk-button :link="context.link.formular">
			Kostenloses Inserat schalten
		</nk-button>

		<nk-wrapper spacing="2xl">
			<nk-row gutter="12" vertical-gutter="0">
				<nk-col v-if="context.biete" cols="full" md="6/12">
					<nk-title size="2xl" no-margin>Biete</nk-title>
					<div class="-rfs-my-6">
						<nk-template-pinnwand-uebersicht
							:context="{pinnwand: context.biete}"
						/>
					</div>
					<nk-button v-if="context.link.biete" :link="context.link.biete">
						Alle anzeigen
					</nk-button>
				</nk-col>
				<nk-col v-if="context.suche" cols="full" md="6/12">
					<nk-title size="2xl" no-margin>Suche</nk-title>
					<div class="-rfs-my-6">
						<nk-template-pinnwand-uebersicht
							:context="{pinnwand: context.suche}"
						/>
					</div>
					<nk-button v-if="context.link.suche" :link="context.link.suche">
						Alle anzeigen
					</nk-button>
				</nk-col>
			</nk-row>
		</nk-wrapper>
	</nk-wrapper>
</template>

<script>
import TemplatesDefault from '#nk/mixins/templates-default';
import NkTemplatePinnwandUebersicht from '#nk/components/templates/NkTemplatePinnwandUebersicht';

export default {
	name: 'TemplatePinnwandPortal',

	components: {NkTemplatePinnwandUebersicht},

	mixins: [TemplatesDefault],

	data() {
		return {};
	},
};
</script>
